$(function () {
  var winWide = window.screen.width;
  if (winWide > 767) {
        $(".wd-new-index-bestsellers-product-img").hover(function(){
      $(this).find(".wd-index-bestsellers-hover-img-1").stop(true,true).fadeOut();
      $(this).find(".wd-index-bestsellers-hover-img-2").stop(true,true).fadeIn();
    },function(){
      $(this).find(".wd-index-bestsellers-hover-img-1").stop(true,true).fadeIn();
      $(this).find(".wd-index-bestsellers-hover-img-2").stop(true,true).fadeOut();
    });
    $(".wd-new-index-scenes-banner-button").click(function(){
      $(".wd-new-index-scenes-banner-hide").hide();
      $(this).parent().find(".wd-new-index-scenes-banner-hide").show();
      $('.wd-new-index-scenes-banner-button-left').css('animation','wd-new-index-scenes-animation-left-2 3s infinite');
      $('.wd-new-index-scenes-banner-button-right').css('animation','wd-new-index-scenes-animation-right-2 3s infinite');
//       $('.wd-new-index-scenes-banner-button').css('pointer-events','none');
    })
    $(".wd-new-index-scenes-banner-product-close").click(function(){
      $(this).parent().parent().parent().find(".wd-new-index-scenes-banner-hide").hide();
      $('.wd-new-index-scenes-banner-button-left').css('animation','wd-new-index-scenes-animation-left 3s infinite');
      $('.wd-new-index-scenes-banner-button-right').css('animation','wd-new-index-scenes-animation-right 3s infinite');
//       $('.wd-new-index-scenes-banner-button').css('pointer-events','auto');
    })
    $('.wd-new-index-scenes-banner-background').not('.wd-new-index-scenes-banner-button').click(function(){
      $('.wd-new-index-scenes-banner-hide').hide();
      $('.wd-new-index-scenes-banner-button-left').css('animation','wd-new-index-scenes-animation-left 3s infinite');
      $('.wd-new-index-scenes-banner-button-right').css('animation','wd-new-index-scenes-animation-right 3s infinite');
    })
  }else {
    $('.wd-new-index-scenes-banner-button').click(function () {
      $(this).parent().find('.wd-new-index-scenes-banner-hide-mobile').show();
      $('.wd-new-index-scenes-mask').show();
      $('html').addClass('wd-new-index-scenes-scroll-mask');
    })
    $('.wd-new-index-scenes-banner-product-close').click(function () {
      $(this).parent().parent().parent().find('.wd-new-index-scenes-banner-hide-mobile').hide();
      $('.wd-new-index-scenes-mask').hide();
      $('html').removeClass('wd-new-index-scenes-scroll-mask');
    })
    $('.wd-new-index-scenes-mask').not('.wd-new-index-scenes-banner-hide-mobile').click(function () {
      $('.wd-new-index-scenes-banner-hide-mobile').hide();
      $('.wd-new-index-scenes-mask').hide();
      $('html').removeClass('wd-new-index-scenes-scroll-mask');
    })
  }
})
$(window).scroll(function () {
    let index_offset_top = $(window).scrollTop();
    let index_choose_height = $(".wd-product-vis-choose").offset().top;
    if (index_offset_top >= index_choose_height - 400) {
      $(".wd-product-vis-choose").addClass("wd-product-vis-choose-active");
    } else {
      $(".wd-product-vis-choose").removeClass("wd-product-vis-choose-active");
    }
  });
if(screen.width>767){ 
  $(".wd-homepage-product-list-title a").mouseenter(function(){
    for(var i=0;i<$(".wd-homepage-product-hide-plate").length;i++){
      $(".wd-homepage-product-hide-plate")[i].className = 'wd-homepage-product-hide-plate';
      $(".wd-homepage-product-list-title a")[i].setAttribute('index',i);
    }
    $($(".wd-homepage-product-hide-plate")[this.getAttribute('index')]).addClass("wd-homepage-product-show-plate");

    for(var i=0;i<$(".wd-homepage-product-list-title").length;i++){
      $(".wd-homepage-product-list-title a")[i].className = '';
      $(".wd-homepage-product-list-title a")[i].setAttribute('index',i);
    }
    $($(".wd-homepage-product-list-title a")[this.getAttribute('index')]).addClass("wd-homepage-product-list-title-hover");
  });
}else{
  $(".wd-homepage-product-list-title-mobile a").click(function(){
    for(var i=0;i<$(".wd-homepage-product-hide-plate").length;i++){
      $(".wd-homepage-product-hide-plate")[i].className = 'wd-homepage-product-hide-plate';
      $(".wd-homepage-product-list-title-mobile a")[i].setAttribute('index',i);
    }
    $($(".wd-homepage-product-hide-plate")[this.getAttribute('index')]).addClass("wd-homepage-product-show-plate");

    for(var i=0;i<$(".wd-homepage-product-list-title-mobile").length;i++){
      $(".wd-homepage-product-list-title-mobile a")[i].className = '';
      $(".wd-homepage-product-list-title-mobile a")[i].setAttribute('index',i);
    }
    $($(".wd-homepage-product-list-title-mobile a")[this.getAttribute('index')]).addClass("wd-homepage-product-list-title-hover");
  });

  // swiper
  var mySwiper = new Swiper ('.wd-swiper1', {
    roundLengths : true,
    autoHeight: true,
    spaceBetween: 15,
    clickable :true,
    pagination: {
      el: '.wd-swiper-pagination1',
    },
  })
  var mySwiper = new Swiper ('.wd-swiper2', {
    roundLengths : true,
    autoHeight: true,
    spaceBetween: 15,
    clickable :true,
    pagination: {
      el: '.wd-swiper-pagination2',
    },
  })
  var myswiper = new Swiper('.wd-swiper3', {
    slidesPerView: 2.5,
    spaceBetween: 30,
    freeMode: true,
  });
}

// index new js

var swiper1 = new Swiper(".wd-index-swiper-policy", {
  navigation: {
    nextEl: ".wd-index-swiper-policy-navigation-right",
    prevEl: ".wd-index-swiper-policy-navigation-left",
  },
});
var swiper2 = new Swiper(".wd-customer-review-swiper", {
  spaceBetween : 24,
  loop: true,
  navigation: {
    nextEl: ".wd-customer-review-swiper-navigation-right",
    prevEl: ".wd-customer-review-swiper-navigation-left",
  },
});
var swiper3 = new Swiper ('.wd-new-index-blogs-swiper-container', {
  roundLengths : true,
  autoHeight: true,
  spaceBetween: 15,
  clickable :true,
  pagination: {
    el: '.wd-new-index-blog-pagination',
  },
})
var swiper6 = new Swiper(".wd-customer-review-swiper-new", {
  effect: "fade",
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: ".wd-customer-review-swiper-button-next",
    prevEl: ".wd-customer-review-swiper-button-prev",
  },
});


swiper6.el.onmouseover = function(){
  swiper6.autoplay.stop();
}
swiper6.el.onmouseleave = function(){
  swiper6.autoplay.start();
}

$(function () {
  var winWide = window.screen.width;
  if (winWide <= 1024) {
    var swiper4 = new Swiper(".wd-new-index-family-swiper-container", {
      spaceBetween: 40,
      loop: true,
    });
  }else {
    var swiper5 = new Swiper(".wd-new-index-family-swiper-container", {
      slidesPerView: 5,
      spaceBetween: 40,
    });
    $(".wd-new-index-family-swiper-slide").hover(function(){
      $(this).find(".wd-new-index-family-swiper-hover-background-hide").stop(true,true).fadeIn("slow");
      $(this).find(".wd-new-index-family-swiper-img").css("filter","blur(10px)");
    },function(){
      $(this).find(".wd-new-index-family-swiper-hover-background-hide").stop(true,true).fadeOut("slow");
      $(this).find(".wd-new-index-family-swiper-img").css("filter","none");
    })
  }
  
   $(".wd-new-index-scenes_kitchen").click(function(){
    $(".wd-new-index-scenes-banner-1").fadeIn();
    $(".wd-new-index-scenes-banner-2").fadeOut();
    $(".wd-new-index-scenes_kitchen").addClass("toggle-bar-active");
    $(".wd-new-index-scenes_livingroom").removeClass("toggle-bar-active");
  })
  $(".wd-new-index-scenes_livingroom").click(function(){
    console.log(555)
    $(".wd-new-index-scenes-banner-2").fadeIn();
    $(".wd-new-index-scenes-banner-1").fadeOut();
    $(".wd-new-index-scenes_livingroom").addClass("toggle-bar-active");
    $(".wd-new-index-scenes_kitchen").removeClass("toggle-bar-active");
  })
})



$('.wd-customer-review-swiper-button').mouseenter(function () {
  $('.wd-customer-review-swiper-button-icon-semicircle-top').css('animation', 'animation-top-enter 0.5s');
  $('.wd-customer-review-swiper-button-icon-semicircle-bottom').css('animation', 'animation-bottom-enter 0.5s');
  $('.wd-customer-review-swiper-button-icon-semicircle-top').css('animation-fill-mode', 'forwards');
  $('.wd-customer-review-swiper-button-icon-semicircle-bottom').css('animation-fill-mode', 'forwards');
})
$('.wd-customer-review-swiper-button').mouseleave(function () {
  $('.wd-customer-review-swiper-button-icon-semicircle-top').css('animation', 'animation-top-leave 0.5s');
  $('.wd-customer-review-swiper-button-icon-semicircle-bottom').css('animation', 'animation-bottom-leave 0.5s');
  $('.wd-customer-review-swiper-button-icon-semicircle-top').css('animation-fill-mode', 'forwards');
  $('.wd-customer-review-swiper-button-icon-semicircle-bottom').css('animation-fill-mode', 'forwards');
})

// new index js end

// Media Attention start
 var swiper = new Swiper(".wd-v2-index-media-swiper", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            MouseEvent: true,
            navigation: {
                nextEl: ".wd-v2-index-media-swiper-next",
                prevEl: ".wd-v2-index-media-swiper-prev",
            },
        });


        $('.wd-v2-index-media-all .wd-v2-index-media-swiper .swiper-wrapper .wd-v2-index-media-swiper-slide').hover(function () {
            $(this).addClass('wd-v2-index-media-active').siblings('.wd-v2-index-media-swiper-slide').removeClass('wd-v2-index-media-active');
            var i = $(this).index();
            $(this).parents().siblings('.wd-v2-index-media-content').find('div').eq(i).show().siblings('div').hide();
        });
 // Media Attention end 




// <!-- category swiper start -->
var swiper = new Swiper(".wd-v2-index-category-swiper", {
            slidesPerView: 'auto',
            spaceBetween: 30,

            navigation: {
                nextEl: ".wd-v2-index-category-swiper-next",
                prevEl: ".wd-v2-index-category-swiper-prev",
            },
        });

        $('.wd-v2-index-category-mobile-btn').click(function () {
            $('.wd-v2-index-category-mobile-bottom-box').css("display", "grid")
            $(this).css("display", "none")
        })
// <!-- category swiper end -->


// Media Attention start
 var swiper = new Swiper(".wd-v2-index-media-swiper", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            MouseEvent: true,
            navigation: {
                nextEl: ".wd-v2-index-media-swiper-next",
                prevEl: ".wd-v2-index-media-swiper-prev",
            },
        });


        $('.wd-v2-index-media-all .wd-v2-index-media-swiper .swiper-wrapper .wd-v2-index-media-swiper-slide').hover(function () {
            $(this).addClass('wd-v2-index-media-active').siblings('.wd-v2-index-media-swiper-slide').removeClass('wd-v2-index-media-active');
            var i = $(this).index();
            $(this).parents().siblings('.wd-v2-index-media-content').find('div').eq(i).show().siblings('div').hide();
        });
 // Media Attention end 






        var wd_index_scenes_screenWidth = window.innerWidth;
        var wd_index_scenes_screenHeight = window.innerHeight;
        var wd_index_scenes_portrait = wd_index_scenes_screenWidth < wd_index_scenes_screenHeight;
        var wd_index_scenes_img1 = document.getElementById("wd_index_scenes_img1");
        var wd_index_scenes_img2 = document.getElementById("wd_index_scenes_img2");

        if (wd_index_scenes_screenWidth > 1024) {
          gsap.registerPlugin(ScrollTrigger)

    let tl_more_secure = gsap.timeline({
        scrollTrigger: {
            trigger: ".wd-new-index-scenes-banner-parent",
            pin: true,
            scrub: 1,
            start: "top top",
            pinSpacing: true,
            once: false,
            duration: 2,
            ease: "power1.out",
        },
    });
    tl_more_secure
        .to(".wd-new-index-scenes-banner-transform", {
            width:"100%",
            duration: 1,
        },0.1 ) 
       .to(".wd-new-index-scenes-banner-background img", {
            borderRadius:0,
        }, 0.1) 
       .to(".wd-new-index-scenes-v2-title ", {
            opacity: 0,
            duration: 0.5,
        }, )
       .to(".wd-new-index-scenes-banner-content", {
            opacity: 1,
            duration: 0.5,
        }, )
       
       .to(".wd-new-index-scenes-banner-toggle-bar", {
            display: "flex",
            duration: 0.5,
        }, )
       .to(".wd-new-index-scenes-banner-toggle-bar", {
            opacity: 1,
            duration: 0.5,
        }, )
    tl_more_secure.to(".wd-new-index-scenes-banner-1", {
            duration: 3
        });
        }
